import {useState, useEffect} from 'react';
import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import AssetHelperService from '../../Service/Assets/AssetHelperService';

export const useAssetHelperService = (server: APIServer) => {
  const [api, setAPI] = useState<AssetHelperService>(new AssetHelperService(server));

  useEffect(() => {
    setAPI(new AssetHelperService(server));
  }, [server]);

  return api;
};
